export default "__VITE_ASSET__de0a875d__"